var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "teamInfo" } }, [
            _vm._v("球队信息")
          ]),
          _c("el-menu-item", { attrs: { index: "studentmanage" } }, [
            _vm._v("学生管理")
          ]),
          _c("el-menu-item", { attrs: { index: "trainmanage" } }, [
            _vm._v("训练管理")
          ]),
          _c("el-menu-item", { attrs: { index: "eventmanage" } }, [
            _vm._v("赛事管理")
          ]),
          _c("el-menu-item", { attrs: { index: "parentList" } }, [
            _vm._v("家长")
          ])
        ],
        1
      ),
      _c("teamInfo", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "teamInfo",
            expression: "activeIndex == 'teamInfo'"
          }
        ],
        ref: "teamInfo",
        attrs: { teamId: _vm.teamId }
      }),
      _c("studentmanage", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "studentmanage",
            expression: "activeIndex == 'studentmanage'"
          }
        ],
        ref: "studentmanage",
        attrs: { teamId: _vm.teamId }
      }),
      _c("trainmanage", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "trainmanage",
            expression: "activeIndex == 'trainmanage'"
          }
        ],
        ref: "trainmanage",
        attrs: { teamId: _vm.teamId }
      }),
      _c("eventmanage", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "eventmanage",
            expression: "activeIndex == 'eventmanage'"
          }
        ],
        ref: "eventmanage",
        attrs: { teamId: _vm.teamId }
      }),
      _c("parent-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "parentList",
            expression: "activeIndex == 'parentList'"
          }
        ],
        ref: "parentList",
        attrs: { teamId: _vm.teamId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }